/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptOrganizationInvitationRequestDTO,
  AcceptOrganizationInvitationResponseDTO,
  InvitationGetPendingInvitationsParams,
  InvitationValidateInvitationParams,
  OrganizationInvitationDTOQueryResultDTO,
  ValidateOrganizationInvitationResponseDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const invitationValidateInvitation = (
    params?: InvitationValidateInvitationParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ValidateOrganizationInvitationResponseDTO>(
      {url: `/api/Invitation/validate`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getInvitationValidateInvitationQueryKey = (params?: InvitationValidateInvitationParams,) => {
    return [`/api/Invitation/validate`, ...(params ? [params]: [])] as const;
    }

    
export const getInvitationValidateInvitationQueryOptions = <TData = Awaited<ReturnType<typeof invitationValidateInvitation>>, TError = ErrorType<unknown>>(params?: InvitationValidateInvitationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationValidateInvitation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvitationValidateInvitationQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof invitationValidateInvitation>>> = ({ signal }) => invitationValidateInvitation(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invitationValidateInvitation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvitationValidateInvitationQueryResult = NonNullable<Awaited<ReturnType<typeof invitationValidateInvitation>>>
export type InvitationValidateInvitationQueryError = ErrorType<unknown>


export function useInvitationValidateInvitation<TData = Awaited<ReturnType<typeof invitationValidateInvitation>>, TError = ErrorType<unknown>>(
 params: undefined |  InvitationValidateInvitationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationValidateInvitation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationValidateInvitation>>,
          TError,
          Awaited<ReturnType<typeof invitationValidateInvitation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationValidateInvitation<TData = Awaited<ReturnType<typeof invitationValidateInvitation>>, TError = ErrorType<unknown>>(
 params?: InvitationValidateInvitationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationValidateInvitation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationValidateInvitation>>,
          TError,
          Awaited<ReturnType<typeof invitationValidateInvitation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationValidateInvitation<TData = Awaited<ReturnType<typeof invitationValidateInvitation>>, TError = ErrorType<unknown>>(
 params?: InvitationValidateInvitationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationValidateInvitation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useInvitationValidateInvitation<TData = Awaited<ReturnType<typeof invitationValidateInvitation>>, TError = ErrorType<unknown>>(
 params?: InvitationValidateInvitationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationValidateInvitation>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvitationValidateInvitationQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const invitationGetPendingInvitations = (
    params?: InvitationGetPendingInvitationsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationInvitationDTOQueryResultDTO>(
      {url: `/api/Invitation/pending`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getInvitationGetPendingInvitationsQueryKey = (params?: InvitationGetPendingInvitationsParams,) => {
    return [`/api/Invitation/pending`, ...(params ? [params]: [])] as const;
    }

    
export const getInvitationGetPendingInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof invitationGetPendingInvitations>>, TError = ErrorType<unknown>>(params?: InvitationGetPendingInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationGetPendingInvitations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvitationGetPendingInvitationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof invitationGetPendingInvitations>>> = ({ signal }) => invitationGetPendingInvitations(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invitationGetPendingInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvitationGetPendingInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof invitationGetPendingInvitations>>>
export type InvitationGetPendingInvitationsQueryError = ErrorType<unknown>


export function useInvitationGetPendingInvitations<TData = Awaited<ReturnType<typeof invitationGetPendingInvitations>>, TError = ErrorType<unknown>>(
 params: undefined |  InvitationGetPendingInvitationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationGetPendingInvitations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationGetPendingInvitations>>,
          TError,
          Awaited<ReturnType<typeof invitationGetPendingInvitations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationGetPendingInvitations<TData = Awaited<ReturnType<typeof invitationGetPendingInvitations>>, TError = ErrorType<unknown>>(
 params?: InvitationGetPendingInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationGetPendingInvitations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationGetPendingInvitations>>,
          TError,
          Awaited<ReturnType<typeof invitationGetPendingInvitations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationGetPendingInvitations<TData = Awaited<ReturnType<typeof invitationGetPendingInvitations>>, TError = ErrorType<unknown>>(
 params?: InvitationGetPendingInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationGetPendingInvitations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useInvitationGetPendingInvitations<TData = Awaited<ReturnType<typeof invitationGetPendingInvitations>>, TError = ErrorType<unknown>>(
 params?: InvitationGetPendingInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationGetPendingInvitations>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvitationGetPendingInvitationsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const invitationAcceptInvitation = (
    acceptOrganizationInvitationRequestDTO: AcceptOrganizationInvitationRequestDTO,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AcceptOrganizationInvitationResponseDTO>(
      {url: `/api/Invitation/accept`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: acceptOrganizationInvitationRequestDTO, signal
    },
      );
    }
  


export const getInvitationAcceptInvitationMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationAcceptInvitation>>, TError,{data: AcceptOrganizationInvitationRequestDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof invitationAcceptInvitation>>, TError,{data: AcceptOrganizationInvitationRequestDTO}, TContext> => {
    
const mutationKey = ['invitationAcceptInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invitationAcceptInvitation>>, {data: AcceptOrganizationInvitationRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  invitationAcceptInvitation(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvitationAcceptInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof invitationAcceptInvitation>>>
    export type InvitationAcceptInvitationMutationBody = AcceptOrganizationInvitationRequestDTO
    export type InvitationAcceptInvitationMutationError = ErrorType<unknown>

    export const useInvitationAcceptInvitation = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationAcceptInvitation>>, TError,{data: AcceptOrganizationInvitationRequestDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof invitationAcceptInvitation>>,
        TError,
        {data: AcceptOrganizationInvitationRequestDTO},
        TContext
      > => {

      const mutationOptions = getInvitationAcceptInvitationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const invitationAcceptInvitationById = (
    invitationId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AcceptOrganizationInvitationResponseDTO>(
      {url: `/api/Invitation/${invitationId}/accept`, method: 'POST', signal
    },
      );
    }
  


export const getInvitationAcceptInvitationByIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationAcceptInvitationById>>, TError,{invitationId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof invitationAcceptInvitationById>>, TError,{invitationId: number}, TContext> => {
    
const mutationKey = ['invitationAcceptInvitationById'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invitationAcceptInvitationById>>, {invitationId: number}> = (props) => {
          const {invitationId} = props ?? {};

          return  invitationAcceptInvitationById(invitationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvitationAcceptInvitationByIdMutationResult = NonNullable<Awaited<ReturnType<typeof invitationAcceptInvitationById>>>
    
    export type InvitationAcceptInvitationByIdMutationError = ErrorType<unknown>

    export const useInvitationAcceptInvitationById = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationAcceptInvitationById>>, TError,{invitationId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof invitationAcceptInvitationById>>,
        TError,
        {invitationId: number},
        TContext
      > => {

      const mutationOptions = getInvitationAcceptInvitationByIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    